/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import {
  ISearchMediaReq,
  ISearchMediaRes,
  TMediaType,
} from '@/interfaces/media';
import { AxiosResponse } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { searchMedias } from '@/adapters/media';
import MediaCard from '../card/media-card';

interface IProps {
  modelId: number | null;
  modelType: TMediaType;
  open: boolean;
  onCancel: () => void;
}

const _criteria: ISearchMediaReq = {
  orderBy: 'id',
  orderType: 'descend',
  pageSize: -1,
  pageStart: 1,
  search: '',
  modelType: 'order',
};

const MediaViewModal = ({ open, onCancel, modelId, modelType }: IProps) => {
  const [criteria] = useState<ISearchMediaReq>({
    ..._criteria,
  });
  const { data: medias } = useQuery<AxiosResponse<ISearchMediaRes>, Error>({
    queryKey: ['search-media', criteria],
    queryFn: async () =>
      await searchMedias({
        ...criteria,
        modelId: Number(modelId || 0),
        modelType,
      }),
    enabled: !!modelId && !!modelType,
  });

  const documents = medias?.data?.data || [];

  return (
    <Modal
      title="ไฟล์เอกสาร"
      open={open}
      onCancel={() => {
        onCancel();
      }}
      footer={
        <div className="flex w-full gap-2 justify-center">
          <Button key="back" onClick={onCancel}>
            ปิด
          </Button>
        </div>
      }
      destroyOnClose
    >
      <div className="flex flex-col gap-2">
        {(documents?.length &&
          documents.map(d => {
            return (
              <MediaCard
                key={d.id}
                media={d}
                onDeleted={() => console.log()}
                isDownload
                readonly
              />
            );
          })) || (
          <div className="flex w-full justify-center">ไม่พบไฟล์เอกสาร</div>
        )}
      </div>
    </Modal>
  );
};

export default MediaViewModal;
